<div class="item-list" *ngIf="contact">
  <div>
    <div>
      <div class="container-fluid">

        <div class="row">
          <div class="form-group col-md-10">
            <input type="text" class="form-control" name="contactValue" class="form-control" [(ngModel)]="contact.value"
              #contactValue="ngModel" required />
            <small class="text-danger" *ngIf="(contactValue.touched || contactValue.dirty) && !contactValue.valid">
              Value is required.
            </small>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-10">
            <label for="default-marker">Primary</label>
            <input [(ngModel)]="contact.isDefault" type="checkbox" id="default-marker" />
          </div>
        </div>

      </div>
    </div>
  </div>
  <button type="button" class="btn btn-danger list-item-close" aria-label="Close" (click)="deleteContact()">
    <i class="fa fa-times" aria-hidden="true"></i>
  </button>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offers/contact/contact.component.html